import breakpoints from './breakpoints';
import grid from './grid';
import colors from './colors';
import durations from './durations';
import typographicScale from './typographicScale';
import text from './text';
import heading from './heading';
import link from './link';
import button from './button';
import textInput from './textInput';


let defaults: any = {
	breakpoints,
	grid,
	colors,
	durations,
	typographicScale,
	text,
	heading,
	link,
	button,
	textInput
};

export default defaults;
